<template>
  <div class="case-page-content">
    <sticky-bar :anchors="anchors"></sticky-bar>

    <ul class="mb-list">
      <li v-for="(item, idx) in cases"
          :key="idx">
        <div class="img-wraper">
          <img :src="item.cover" :alt="item.title">
        </div>
        <h2>{{item.name}}</h2>
        <h4>{{item.type}}</h4>
        <div class="pra">{{item.abstrct}}</div>
      </li>
    </ul>

    <div class="data-origin">
      <p class="case-origin">数据来源：一维科技商务部</p>
    </div>
  </div>
</template>

<script>
  import StickyBar from '../components/stickyBar.vue'

  export default {
    data () {
      return {
        anchors: [{
          title: '生物识别',
          name: 'mCase',
          params: {type: 'bio'},
          icon: null
        }, {
          title: '智慧人社',
          name: 'mCase',
          params: {type: 'ssoc'},
          icon: null
        }, {
          title: '在线教育',
          name: 'mCase',
          params: {type: 'oedu'},
          icon: null
        }, {
          title: '智慧医保',
          name: 'mCase',
          params: {type: 'hins'},
          icon: null
        }],
//        数据控制
        show: null,

        data: {
          bio: [{
            name: '河南省社保局',
            type: '生物识别资格认证项目',
            abstrct: '河南省生物识别认证系统，实现全省认证业务的集中管理，已覆盖全省养老、医保、工伤、就业各险种业务场景。参保人员在任何地方都可以方便快捷地通过智能终端、移动终端和服务网点完成各类身份认证，确保各类基金安全，提升社会化公共服务质量和水平。',
            cover: require('../../static/images/mobile/case/hn-bio.jpg')
          }, {
            name: '河北省社保局',
            type: '人脸识别项目',
            abstrct: '河北省养老保险人脸识别资格认证系统，实现信息认证系统全省集中管理，从根源上杜绝冒领现象重复发生。已在全省197区县内完成上线，做到生物识别认证技术全覆盖，监控参保待遇领取人员生存状态情况，督导各地及时发现并解决问题，有效防范和化解风险。',
            cover: require('../../static/images/mobile/case/hn-face.jpg')
          }, {
            name: '吉林省医保局',
            type: '大医保项目',
            abstrct: '吉林省大医保信息系统，打造从后端到前端完整的医保生物识别身份认证的流程，覆盖省内现有5000多家两定机构，通过建设与社保卡衔接的生物识别身份认证服务实现实名就医、实名购药、远程查房等需求。在规范医疗行为的同时，为医保服务对象提供更优质、更全面的服务，确保医保基金安全，同时提升社会化服务质量和水平。',
            cover: require('../../static/images/mobile/case/jl-hop.jpg')
          }, {
            name: '云南省人社厅',
            type: '生物特征识别系统',
            abstrct: '云南省人社厅生物识别资格认证省集中平台于2016年12月签约，2017年逐步启动全省人社系统内全业务的应用。目前，平台已完成全省城乡居民待遇领取人员基本信息及人脸照片特征数据采集工作，预计2018年内覆盖全省范围4700余万人群。作为国内首例全省生物识别运营项目，一维科技力争打造成为全国规模最大、效率最高、服务最优的省级生物识别资格认证系统，并提供可复制、可推广的经验和模式。',
            cover: require('../../static/images/mobile/case/yn-bio.jpg')
          }, {
            name: '重庆市社保局',
            type: '养老资格认证项目',
            abstrct: '重庆市养老待遇领取人员指纹认证服务系统采取“指纹认证为主，人脸认证为辅”的认证模式，截止到2016年底已完成全市四十个区县，1054个街道（乡镇）的全覆盖，在10000多个村社设立资格核查工作点，覆盖养老人群近90%。自系统建成后，通过生物验证，有效遏制了冒领养老金现象的发生，在一定程度上保障了社保基金的安全。',
            cover: require('../../static/images/mobile/case/cq-vfy.jpg')
          }],
          ssoc: [{
            name: '广东省人社厅',
            type: '“小粤”智能问答机器人',
            abstrct: '“小粤”智能机器人是一维科技以自然语言处理、深度学习及知识图谱为核心技术而打造的“智能+”客服服务机器人。她通过语音识别和语义识别，来实现人与机器的自然交互。其丰富的智能知识库覆盖了人社各个业务领域的政策要点。目前已经接入了广东人社的微信公众号以及广东人社的APP应用，为广东的广大群众提供了24小时全天候在线、急速智能的响应服务。',
            cover: require('../../static/images/mobile/case/gz-kf.jpg')
          }, {
            name: '苏州市人社局',
            type: '“苏小妹”智能问答机器人',
            abstrct: '苏州“苏小妹”智能机器人是一维科技 “小易” 智能机器人的第二代产品。“苏小妹”以全新的交互界面打造更好的用户体验，对接苏州人社的微信公众号，实现各类政策问题、办事指南的在线咨询。同时，“苏小妹”还能利用大数据智能分析技术来精准识别出用户的需求并给出推荐；后台对接到核心业务系统，打通业务的经办渠道来一站式解决用户问题，整体服务更加智能、高效，应答准确率达95%以上。',
            cover: require('../../static/images/mobile/case/sz-kf.jpg')
          }],
          oedu: [{
            name: '陕西省就业局',
            type: '职业培训云平台',
            abstrct: '陕西职业培训云平台是一个运用移动互联网、流媒体、云平台、生物认证等技术而搭建的在线职业培训云平台。该平台有效的整合优质培训资源，实现了全省教学资源的共享和教学资源的循环利用；利用现代信息技术，实现职业培训教育的在线化、实现教学资源的资产积累；有效提高了陕西省职业培训的灵活性、便捷性、高效性，实现了职业培训与服务业务的新突破。',
            cover: require('../../static/images/mobile/case/sx-ypt.jpg')
          }],
          hins: [{
            name: '吉林省医保局',
            type: '医保智能监控',
            abstrct: '结合吉林省“大医保”项目的整体要求，通过生物识别技术实现医保就医的实人实名制，同时利用生物生别技术开展远程查房、慢病管理等应用，提高了医保监管的智能化水平。',
            cover: require('../../static/images/mobile/case/jl-yb.jpg')
          }, {
            name: '吉林省医保局',
            type: 'DRGs项目',
            abstrct: '本项目实现了省直医保及省异地就医相关数据的集中。并按照国家和省有关DRGs工作要求，结合省直医疗保险实际，建立DRGs病种组付费管理系统，主要内容包括：标准制定和数据规范、DRGs病种组相应算法、执行情况考评及结算等。',
            cover: require('../../static/images/mobile/case/jl-drgs.jpg')
          }]
        }
      }
    },
    watch: {
      '$route' (to, from) {
        this.show = to.params.type || 'bio';
      }
    },
    computed: {
      cases () {
        return this.data[this.show];
      }
    },
    methods: {
      switcher (i) {
        this.$refs.carousel[i].swipe();
      },
      showDetail (p, c) {
        var show = this.casea[p].cover[c];

        this.Viewer.type = show.type || 'IMAGE';
        this.Viewer.url = (show.detail || show.cover) + '?date=' + new Date();
      }
    },
    components: {
      StickyBar
    },
    created () {
      this.show = this.$route.params.type || 'bio';
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .mobile .case-page-content {
    .sticky-list{
     width: 6.95rem;
    }
    .mb-list{
      h2,
      h4{
        font-size: .40rem;
        color: #3b3b3b;
        font-weight: bold;
        margin-bottom: .24rem;
      }
      .pra{
        color: #515151;
        font-size: .28rem;
        margin-top: .55rem;
        line-height: .504rem;
      }
    }

    .data-origin {
      text-align: center;
      padding-top: .40rem;
      padding-bottom: .40rem;
      background: #fff;
      border-bottom: 1px solid #f6f6f6;
      .case-origin{
        line-height: 1.5em;
        font-size: .20rem;
        color: #979696;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/mobile/Case.vue